import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Wordmark } from '../components/site/Header';

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground" data-testid="terms-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
        <div className="mt-8"><Wordmark /></div>
        <h1 className="font-display font-semibold text-3xl sm:text-4xl tracking-tight mt-6">Terms of Use</h1>
        <p className="text-sm text-muted-foreground mt-2">Melopa Invents Private Limited (“MELOPA INFRA”)</p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-foreground/85">
          <p>
            By using melopainfra.com you agree to these terms. The website is operated by Melopa Invents Private Limited
            under the brand MELOPA INFRA.
          </p>
          <h2 className="font-display font-semibold text-lg">Informational content</h2>
          <p>
            Content on this website — including descriptions of the EPS wall and roof panel system, visualisations and
            representative project concepts — is provided for general information. Visual representations are conceptual
            and do not constitute completed project claims. Specific structural performance, specifications and pricing
            are confirmed only through a project-specific engineering review and written proposal.
          </p>
          <h2 className="font-display font-semibold text-lg">Enquiries and estimates</h2>
          <p>
            Submitting a project enquiry does not create a contractual obligation. Any estimate or proposal shared by our
            team is indicative until a formal agreement is executed.
          </p>
          <h2 className="font-display font-semibold text-lg">Contact</h2>
          <p>
            Questions regarding these terms can be sent to{' '}
            <a href="mailto:hello@melopainfra.com" className="text-[#155E6D] underline">hello@melopainfra.com</a>.
          </p>
        </div>

        <p className="mt-12 text-xs text-muted-foreground">
          MELOPA INFRA is a brand of Melopa Invents Private Limited. © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
